import './Head.css'

function Head(){
    return (
        /* Jumbotron */
        <div className="jumbotron">
            <h1>The Sanctuary</h1>
            <p className="Slogan">Writing about interests; Computer Science, Philosophy, Artificial Intelligence and more!</p>
            <p>
                <img style={{width: '100%'}} src="/img/banner.jpg" alt="Banner" />
            </p>
        </div>
    );
}

export default Head;